exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bookTextVariety .selection{text-align:center}.bookTextVariety .selection .selected{font-weight:700}.bookTextVariety .verticalDivider{border-left:1px solid #bbb;top:50px;left:50%;height:50px}.bookTextVariety .fiction{width:40%;float:left}.bookTextVariety .nonFiction{width:40%;float:right}.bookTextVariety .optionContainer{padding-top:22px}.bookTextVariety .optionContainer button{margin-bottom:10px}.bookTextVariety .optionContainer div{font-style:italic;font-size:.8em}.bookTextVariety .seperator{margin-top:50px}.bookTextVariety .cancelAction{margin-top:15px;float:left;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/books/book_text_variety.scss
// module id = 1355
// module chunks = 0